import H1 from 'primitives/Typography/Headings/H1';
import { Coords, Market } from 'state/Location/types';
import { get, omit } from 'lodash-es';
import { Helmet } from 'react-helmet';
import { UserInfoSection, UserInfoWrapper } from 'components/UserInfoSection';

export type Props = {
  coordinates?: Coords;
  country: string;
  market: Market;
  postCode: string | number;
  profileId: number | null;
  subscription: string;
};

function UserInfo({
  profileId,
  subscription,
  coordinates,
  market,
  postCode,
  country,
}: Props) {
  return (
    <UserInfoWrapper>
      <Helmet meta={[{ content: 'noindex, nofollow', name: 'ROBOTS' }]} />
      <H1>Information</H1>
      <UserInfoSection title="User">
        <p>Profile ID: {String(profileId)}</p>
        <p>Subscription Level: {subscription}</p>
      </UserInfoSection>
      <UserInfoSection title="Location">
        <p>Latitude: {String(get(coordinates, 'latitude', ''))}</p>
        <p>Longitude: {String(get(coordinates, 'longitude', ''))}</p>
        <p>Postal Code: {String(postCode)}</p>
        <p>Country: {country}</p>
      </UserInfoSection>
      <UserInfoSection title="Market">
        {(
          Object.keys(omit(market, ['loc'])) as Array<
            Exclude<keyof Market, 'loc'>
          >
        ).map(data => (
          <p key={`market-${data}`}>
            {data}: {String(market[data])}
          </p>
        ))}
      </UserInfoSection>
    </UserInfoWrapper>
  );
}

export default UserInfo;
